import Offboard from "../js/components/groupManagement/Offboard.react";
export default Offboard;
